import { USER_ROLES } from 'src/_shared/constants/';

const ANT_TAG_COLORS = ['blue', 'green', 'cyan', 'gold', 'magenta', 'orange', 'geekblue', 'purple', 'lime', 'red', 'pink'];

const ANT_TAG_HEX = {
	blue: '#1677ff',
	green: '#52c41a',
	cyan: '#13c2c2',
	gold: '#faad14',
	magenta: '#eb2f96',
	orange: '#fa8c16',
	geekblue: '#2f54eb',
	purple: '#722ed1',
	lime: '#a0d911',
	red: '#f5222d',
	pink: '#eb2f96',
	default: '#8c8c8c',
};

function hashTag(tag) {
	let hash = 0;
	for (const ch of tag) hash = ((hash << 5) - hash + ch.charCodeAt(0)) | 0;
	return ANT_TAG_COLORS[Math.abs(hash) % ANT_TAG_COLORS.length];
}

export function getAntTagColor(tag) {
	return hashTag(tag);
}

export function getTagHex(tag) {
	return ANT_TAG_HEX[hashTag(tag)] || ANT_TAG_HEX.default;
}

export const BATCH_SIZE = 9;

export const MODERATOR_ROLES = [
	USER_ROLES.ADMIN,
	USER_ROLES.MANAGER,
	USER_ROLES.SUPER_ADMIN,
	USER_ROLES.SUPPORT_ADMIN,
];

export const DEFAULT_ACCENT = '#0d9488';
